



















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import {
  DrivewealthWizardStep,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PreenrollmentCopyParagraphs from "@/employee/components/investments/drivewealth/PreenrollmentCopyParagraphs.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GenericLoadingSpinner,
    PreenrollmentCopyParagraphs,
  }
})
export default class PreenrollmentWidget extends Vue {
  @Prop() hsaInvestmentThreshold: number;
  DrivewealthWizardStep = DrivewealthWizardStep;
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;

  portalCustomizationStore = usePortalCustomizationStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthStore = useDrivewealthStore();


  get partnerName (): string {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get routeLocation (): Location {
    this.drivewealthStore.loadAccountIds({})
        .then(result => {
          if (this.drivewealthStore.accountIds.length < 1) {
            this.signingDocumentStore.markDeleteSignature(this.signingDocumentStore.drivewealthAccountSignatureDocumentKey);
            this.signingDocumentStore.setHsabDrivewealthAccountSignature(null);
          }});
    return (this.custodianSettingsStore.isHsaBankCustodian && !this.signingDocumentStore.hsabDrivewealthAccountSignatureIsSigned)
        ? { name: SharedRoutes.DrivewealthHsabAccountSignature, query: { redirectRoute: RouteNames.DrivewealthPreenrollment } }
        : { name: RouteNames.DrivewealthPreenrollment };
  }
}

